var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { forwardRef } from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { linkDefaultProps } from './props';
import * as S from './styles';
/**
 * Componente de link do Design System OLX
 *
 * Além das props explícitas aqui, também aceita todas as props que poderiam ser passadas para o elemento `<a>` do HTML
 */
export const Link = forwardRef((props, ref) => {
  const {
      children,
      iconLeft,
      iconRight,
      dsParentName,
      size = linkDefaultProps.size,
      tag = linkDefaultProps.tag,
      underline = false,
      href
    } = props,
    rest = __rest(props, ["children", "iconLeft", "iconRight", "dsParentName", "size", "tag", "underline", "href"]);
  return React.createElement(S.LinkContainer, Object.assign({
    "data-ds-component": dsParentName ? "DS-".concat(dsParentName, "-Link") : 'DS-Link'
  }, rest, {
    size: size
  }, tag === 'button' && {
    'data-as': tag
  }, tag === 'a' && {
    href
  }, {
    ref: ref,
    as: tag,
    "data-underline": underline
  }), iconLeft && React.createElement(S.IconWrapper, {
    position: "left",
    size: size,
    "data-testid": "icon-left-link"
  }, iconLeft), children, iconRight && React.createElement(S.IconWrapper, {
    position: "right",
    size: size,
    "data-testid": "icon-right-link"
  }, iconRight));
});
Link.defaultProps = linkDefaultProps;
Link.displayName = 'Link';